/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

enum ActionsVisit {
  VISIT_GLOBAL_SETTINGS = "visit:visitGlobalSettings",
  SEARCH_AUDIT_LOGS = "visit:auditLogs",
}

enum ActionsAdd {
  ADD_SERVICE_COMMITMENT = "add:serviceCommitment",
  ADD_SERVICE_SLA = "add:serviceSla",
  ADD_SERVICE_VERSION = "add:serviceVersion",
  ADD_PRODUCT = "add:product",
  ADD_PRODUCT_SLA = "add:productSla",
  ADD_SERVICE_GROUP = "add:serviceGroup",
  ADD_SERVICE_GROUP_SLA = "add:serviceGroupSla",
  ADD_REQUEST = "add:request",
  ADD_TOOL = "add:tool",
  ADD_CUSTOMER = "add:customer",
  ADD_CUSTOMER_CONTRACT = "add:customerContract",
  ADD_CUSTOMER_PRODUCT = "add:customerProduct",
  ADD_CUSTOMER_EMPLOYEE = "add:customerEmployee",
  ADD_CUSTOMER_CONTACT = "add:customerContract",
  ADD_CUSTOMER_REQUEST = "add:customerRequest",
  ADD_CUSTOMER_ASSIGNMENT = "add:customerAssignment",
  ADD_ASSIGNMENT_SERVICE = "add:assignmentService",
  ADD_APPLICATION_SERVICE = "add:applicationService",
  ADD_APPLICATION = "add:application",
  ADD_ENVIRONMENT = "add:environment",
}

enum ActionsEdit {
  EDIT_SERVICES = "edit:services",
  EDIT_PRODUCT_CATALOG = "edit:productCatalog",
  EDIT_SERVICE_COMMITMENT = "edit:serviceCommitment",
  EDIT_REQUEST_CATALOG = "edit:requestCatalog",
  EDIT_TOOL = "edit:tool",
  EDIT_PREREQUISITES = "edit:prerequisites",
  EDIT_EMPLOYEE = "edit:employee",
  EDIT_ROLES = "edit:roles",
  EDIT_CONTACT_TYPES = "edit:roles",
  EDIT_APPLICATION = "edit:application",
}

enum ActionsDelete {
  DELETE_ROLE = "delete:role",
  DELETE_CUSTOMER = "delete:customer",
  DELETE_CUSTOMER_CONTRACT = "delete:customerContract",
  DELETE_CUSTOMER_ASSIGNMENT = "delete:customerAssignment",
}

enum ActionsOther {
  BULK_UPDATE = "other:bulkUpdate",
}

export const ACTIONS = {
  ...ActionsVisit,
  ...ActionsAdd,
  ...ActionsDelete,
  ...ActionsEdit,
  ...ActionsOther,
} as const;

export type ACTION = typeof ACTIONS[keyof typeof ACTIONS];
